import React, { Component } from 'react';
import {
  Paper,
  TextField,
  FormControl,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { connect, ConnectedProps } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { showNotification } from '../redux/actions';
import ApiClient from '../loopback/apiClient';
import withRouter, { RouteType } from '../hoc/withRouter';

type Props = ReduxProps & RouteType<{ search: string }>;
type State = {
  password: string;
  passwordConfirm: string;
  error?: React.ReactNode;
}

class PasswordResetView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      password: '',
      passwordConfirm: '',
    };
  }

  resetPassword = () => {
    const {
      router,
      showNotification: showNotificationAction,
    } = this.props;
    const {
      password,
    } = this.state;
    const token = router.location.search.split('?token=')[1];
    ApiClient.resetPassword(password.trim(), token)
      .then(() => {
        showNotificationAction(<FormattedMessage id="resetPassword.success" />);
        router.navigate('/login');
      }).catch(() => {
        showNotificationAction(<FormattedMessage id="genericErrorMessage" />);
      });
  };

  render() {
    const {
      password,
      passwordConfirm,
      error,
    } = this.state;
    return (
      <Box
        sx={{
          padding: 0.5,
          display: 'flex',
          justifyContent: 'center',
          minWidth: '100vw',
        }}
      >
        <Paper
          sx={{
            width: 400,
            margin: '0 auto',
            p: '15px',
          }}
          variant="outlined"
        >
          <Typography variant="h5"><FormattedMessage id="resetPassword.heading" /></Typography>
          <FormControl fullWidth>
            <TextField
              type="password"
              label={<FormattedMessage id="resetPassword.passwordLabel" />}
              onChange={(e) => {
                const inputPassword = e.target.value.trim();
                this.setState({ password: inputPassword }, () => {
                  this.setState({ error: inputPassword !== passwordConfirm ? <FormattedMessage id="resetPassword.passwordsDoNotMatch" /> : false });
                });
              }}
              sx={{ my: 1 }}
              variant="outlined"
              size="small"
            />
            <TextField
              type="password"
              label={<FormattedMessage id="resetPassword.passwordConfirmLabel" />}
              onChange={(e) => {
                const inputPasswordConfirm = e.target.value.trim();
                this.setState({ passwordConfirm: inputPasswordConfirm }, () => {
                  this.setState({ error: inputPasswordConfirm !== password ? <FormattedMessage id="resetPassword.passwordsDoNotMatch" /> : false });
                });
              }}
              error={!!error}
              helperText={error}
              sx={{ my: 1 }}
              variant="outlined"
              size="small"
            />
            <Button
              variant="contained"
              onClick={this.resetPassword}
              sx={{ my: 1 }}
              disabled={!!error}
            >
              <FormattedMessage id="resetPassword.buttonLabel" />
            </Button>
          </FormControl>
        </Paper>
      </Box>
    );
  }
}

const dispatchProps = {
  showNotification,
};

const connector = connect(null, dispatchProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(withRouter(PasswordResetView));
